import React from 'react';

const Ceremony = () => {
  return (
    <div className="ceremony-page">
      <div className="ceremony-container">
        <h1 className="page-title">CEREMONY 2026</h1>
        
        <section className="ceremony-section">
          <h2>The World Financial Award 2026</h2>
          <p>
            The World Financial Award 2026 ceremony brings together the most distinguished leaders and 
            organisations across banking, forex, insurance, and investment sectors from around the globe.
          </p>
          <p>
            Join us for an exclusive evening celebrating excellence, innovation, and outstanding 
            achievement in the world of finance. Winners will be presented with the prestigious 
            World Financial Award crystal trophy in recognition of their exceptional contributions.
          </p>
        </section>

        <section className="agenda-section">
          <h3 className="section-heading">Event Details</h3>
          <p>
            The World Financial Award 2026 ceremony will take place in London, United Kingdom. 
            Full event details, including venue, date, and registration information, will be 
            announced shortly.
          </p>

          <div className="ceremony-highlights">
            <div className="highlight-item">
              <h4>Keynote Addresses</h4>
              <p>Industry leaders sharing insights on the future of global finance.</p>
            </div>
            <div className="highlight-item">
              <h4>Award Presentations</h4>
              <p>Recognition of winners across all award categories.</p>
            </div>
            <div className="highlight-item">
              <h4>Networking Reception</h4>
              <p>Connect with fellow professionals and industry decision-makers.</p>
            </div>
            <div className="highlight-item">
              <h4>Gala Dinner</h4>
              <p>An evening of celebration with entertainment and fine dining.</p>
            </div>
          </div>
        </section>

        <section className="ceremony-section">
          <h3 className="section-heading">Past Ceremonies</h3>
          <p>
            Since 2007, the World Financial Award has hosted annual ceremonies recognising 
            excellence in financial services. Each year, hundreds of companies from over 35 
            countries compete for the prestigious award.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Ceremony;
